import { Money, FileButton } from "@/components/common";
import { fmtDate, PAY_METHOD } from "@/lib/util";
import { tr as t, Auto } from "@/lib/i18n";

export const Totals = ({ s }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="statement-totals">
    {[["المطلوب", s.total_fils, "text-slate-900", "total"], ["المدفوع", s.paid_fils, "text-green-700", "paid"], ["المتبقي", s.remaining_fils, "text-orange-600", "remaining"]].map(([l, v, c, k]) => (
      <div key={l} className="rounded-2xl bg-orange-50 border border-orange-100 p-3 text-center">
        <div className="text-sm text-slate-600">{t(l)}</div>
        <Money fils={v} className={`text-lg ${c}`} testid={`statement-${k}`} />
      </div>
    ))}
  </div>
);

export default function FeeList({ s, actions }) {
  if (!s.fees.length) return <p className="text-center text-slate-500 py-6">{t("لا توجد رسوم مسجلة")}</p>;
  return (
    <div className="space-y-3">
      {s.fees.map((f) => (
        <div key={f.id} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`fee-${f.id}`}>
          <div className="flex justify-between gap-2 items-start">
            <div><b className="text-lg"><Auto text={f.fee_label} /></b>{f.description && <div className="text-sm text-slate-500"><Auto text={f.description} /></div>}
              <div className="text-xs text-slate-400">{fmtDate(f.date)}</div></div>
            <div className="text-end"><Money fils={f.effective_fils} /><div className="text-sm text-orange-600">{t("متبقي")} <Money fils={f.remaining_fils} /></div></div>
          </div>
          {f.adjustments.map((a) => <div key={a.id} className="text-sm text-slate-600 mt-1">{t("قيد تصحيح:")} <Money fils={a.amount_fils} /> — <Auto text={a.reason} /></div>)}
          {f.payments.length > 0 && (
            <div className="mt-3 space-y-1.5">
              {f.payments.map((p) => (
                <div key={p.id} className={`flex items-center justify-between gap-2 text-sm rounded-lg px-3 py-2 ${p.reversal_of ? "bg-red-50" : p.reversed ? "bg-slate-50 line-through text-slate-400" : "bg-green-50"}`}>
                  <span>{fmtDate(p.date)} • {t(PAY_METHOD[p.method] || "")} {p.reversal_of && t("(قيد عكسي)")}</span>
                  <span className="flex items-center gap-2"><Money fils={p.amount_fils} />
                    <FileButton fileId={p.receipt_file_id} label={t("الإيصال")} testid={`receipt-${p.id}`} className="btn btn-sm btn-ghost" />
                    {actions && actions.payment(p)}</span>
                </div>
              ))}
            </div>
          )}
          {actions && <div className="mt-3 flex gap-2">{actions.fee(f)}</div>}
        </div>
      ))}
    </div>
  );
}
